export const OBJECTSTORE_PROJECT_AREAS = "ProjectAreas";
export const OBJECTSTORE_PROJECT_AREA_SECTIONS = "ProjectAreaSections";